/*
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:31
 * @LastEditTime: 2022-04-02 17:27:14
 * @Description:
 */
/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/admin/${action[0]}`;

export default class ADMIN {
  static LOGIN_URL = url`login`;
  static LOGOUT_URL = url`logout`;
  static USER(params) {
    return http.get(url`user`, { params });
  }
  static MENU(params) {
    return http.get(url`menu`, { params });
  }
  static IP_LIMIT(data) {
    return http.post(url`iplimit`, data, formConfig);
  }
  static MENU_SETTING(params) {
    return http.post(url`settingmenu`, params);
  }
  static STOP_APPLICATION(data) {
    return http.post(url`stopapplication`, data, formConfig);
  }
}
